<template>
	<div class="navbar-item" :class="[{ 'has-dropdown': oidcIsAuthenticated }, {'is-active': isActiveDropdown}]">
		<a v-if="!oidcIsAuthenticated" @click="authenticateOidc">
            <Icon family="fal" name="fa-sign-in" />
			<span>{{ $t("layout.sign-in") }}</span>
		</a>
		<a v-else class="navbar-link" @click="isActiveDropdown = !isActiveDropdown">
            <figure v-if="oidcUser.picture" class="image is-24x24 mr-1">
                <img class="is-rounded" :src="photoSrc">
            </figure>
			<Icon v-else family="fal" name="fa-user-circle" />
			<span> {{ oidcUser.given_name }} {{ oidcUser.family_name }}</span>
		</a>

		<div v-if="oidcIsAuthenticated" class="navbar-dropdown" >
			<a class="navbar-item" :href="profileLink"> 
                <span>{{ $t("layout.profile") }}</span>
            </a>
			<a class="navbar-item" @click="signOutOidc"> 
                <Icon family="fal" name="fa-sign-out" />
                <span>{{ $t("layout.sign-out") }}</span>
            </a>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
	name: "Sso",
    data() {
        return { isActiveDropdown: false}
    },
	computed: {
		...mapGetters("oidcStore", ["oidcUser", "oidcIsAuthenticated"]),
        profileLink() {
            return `${process.env.VUE_APP_OIDC_AUTHORITY}/account/profile`
        },
        photoSrc() {
            return `${process.env.VUE_APP_OIDC_AUTHORITY}/api/profile/photo/${this.oidcUser.picture}`
        }
	},
	methods: {
		...mapActions("oidcStore", ["authenticateOidc", "signOutOidc"]),
	},
};
</script>